import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12 m-3" }
const _hoisted_4 = { class: "pull-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-circle-left",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Kembali ")
const _hoisted_7 = { class: "card-header border-0 pt-5" }
const _hoisted_8 = { class: "card-title align-items-start flex-column" }
const _hoisted_9 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_10 = { class: "card-body py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/log/crawler",
            class: "btn btn-primary btn-sm"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("h3", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, "Log Crawler Detail " + _toDisplayString(_ctx.name_scraper), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_Datatable, {
        "table-data": _ctx.tableData,
        "table-header": _ctx.tableHeader,
        "enable-items-per-page-dropdown": true,
        key: _ctx.tableKey,
        total: _ctx.total_data,
        "rows-per-page": _ctx.itemsPerPage,
        "current-page": _ctx.currentPage,
        loading: _ctx.is_loading
      }, {
        "cell-scraper_name": _withCtx(({ row: crawler }) => [
          _createTextVNode(_toDisplayString(crawler.scraper_name), 1)
        ]),
        "cell-project": _withCtx(({ row: crawler }) => [
          _createTextVNode(_toDisplayString(crawler.project != null ? crawler.project : "-"), 1)
        ]),
        "cell-topic": _withCtx(({ row: crawler }) => [
          _createTextVNode(_toDisplayString(crawler.topic != null ? crawler.topic : "-"), 1)
        ]),
        "cell-keyword": _withCtx(({ row: crawler }) => [
          _createTextVNode(_toDisplayString(crawler.keyword != null ? crawler.keyword : "-"), 1)
        ]),
        "cell-start": _withCtx(({ row: crawler }) => [
          _createTextVNode(_toDisplayString(_ctx.formatDate(crawler.start.$date)), 1)
        ]),
        "cell-end": _withCtx(({ row: crawler }) => [
          _createTextVNode(_toDisplayString(crawler.end != null ? _ctx.formatDate(crawler.end.$date) : "-"), 1)
        ]),
        "cell-duration": _withCtx(({ row: crawler }) => [
          _createTextVNode(_toDisplayString(crawler.duration), 1)
        ]),
        "cell-count": _withCtx(({ row: crawler }) => [
          _createTextVNode(_toDisplayString(crawler.count), 1)
        ]),
        "cell-log": _withCtx(({ row: crawler }) => [
          _createTextVNode(_toDisplayString(crawler.log), 1)
        ]),
        "cell-status": _withCtx(({ row: crawler }) => [
          _createTextVNode(_toDisplayString(crawler.status), 1)
        ]),
        _: 1
      }, 8, ["table-data", "table-header", "total", "rows-per-page", "current-page", "loading"])
    ])
  ]))
}